import get from 'lodash/get'
import {getDynamicDateRange} from 'redux/modules/currentUser/utils'
import eachDay from 'utils/eachDay'
import moment from 'moment'

export function getReports(state) {
  const {reports} = state
  if (!reports) return null

  return Object.keys(reports).map(reportId => {
    return reports[reportId]
  }).concat().sort((a, b) => {
    return a.createdAt > b.createdAt ? -1 : 1
  })
}

export function getReport(state, reportId) {
  const {reports, today} = state
  if (!reports || !reportId || !reports[reportId]) return null
  const report = reports[reportId]
  const {dynamicDateType} = report
  const {
    start: startDate,
    end: endDate
  } = getDynamicDateRange(dynamicDateType, today, report.startDate, report.endDate)

  return {
    ...report,
    startDate,
    endDate,
    charts: getCharts(state, report, startDate, endDate)
  }
}

export function getCharts(state, report, startDate, endDate) {
  const {permissions} = state.currentUser
  const charts = get(report, 'charts', [])

  if (!permissions) return null

  return charts
    .filter(chart => permissions.read.includes(`@metric/${chart.metric}`))
    .map(chart => {
      return {
        ...chart,
        data: eachDay(startDate, endDate).map(date => ({
          date,
          ...chart.dimensions.map((dimension, index) => get(chart, ['data', moment(date).toDate(), index], 0))
        }))
      }
    })
}



// WEBPACK FOOTER //
// ./client/redux/modules/reports/selectors.js